export default __webpack_public_path__ + "static/media/how_it_works.62272886.png";